import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * PublicRoute component for handling public routes like login/register
 * Automatically redirects authenticated users to dashboard unless it's a cross-platform request
 */
const PublicRoute = ({ component: Component, restricted = false, ...rest }) => {
  const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated ?? false);

  return (
    <Route
      {...rest}
      render={props => {
        // Check for cross-platform authentication parameters
        const urlParams = new URLSearchParams(props.location.search);
        const platform = urlParams.get('platform');
        const isClosetUser = urlParams.get('isClosetUser');
        const isCrossPlatformRequest = platform || isClosetUser;

        // If authenticated and restricted, but this is a cross-platform request, allow access to component
        if (isAuthenticated && restricted && isCrossPlatformRequest) {
          return <Component {...props} />;
        }

        // Standard behavior: redirect authenticated users away from restricted routes
        return isAuthenticated && restricted ? (
          <Redirect to="/dashboard" />
        ) : (
          <Component {...props} />
        );
      }}
    />
  );
};

export default PublicRoute; 